import React from 'react'
import classNames from 'classnames/bind'
import styles from './TableAvatar.module.scss'

const cx = classNames.bind(styles)

interface TableAvatarProps {
  initials: string
  colorIndex?: number
}

export default function TableAvatar({ initials, colorIndex = 1 }: TableAvatarProps) {
  const idx = ((colorIndex - 1) % 6) + 1
  return (
    <div className={cx('avatar', `avatar--${idx}`)}>
      {initials.slice(0, 2).toUpperCase()}
    </div>
  )
}
